<h1 mat-dialog-title class="text-dark text-xl">
  {{ data.id ? 'Modifica Garanzia' : 'Nuova Garanzia' }}
</h1>
<div mat-dialog-content class="w-full">
  <app-warranty-form [data]="data"></app-warranty-form>
</div>
